module.exports = __webpack_public_path__ + "static/media/S (35).8786c865.jpg";